<template>
  <div class="Snippet" :class="[{ 'is-selected': item.isSelected }]" @click="click">
    <h3>{{ item.name }}</h3>
    <p class="Description">{{ item.description || 'no description...' }}</p>
  </div>
</template>
<script>
export default {
  name: 'Snippet',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  methods: {
    click() {
      this.$emit('click', this.item.id);
    },
  },
};
</script>
<style lang="scss">
.Snippet {
  padding: 10px 25px 10px;
  transition: all 0.295s $ease;
  cursor: pointer;
  user-select: none;
  position: relative;
  color: color(white);
  border-bottom: solid 1px rgba(color(white), 0.15);
  border-top: solid 1px rgba(color(white), 0);
  opacity: 0.5;
  width: 100%;

  &:hover {
    color: color(white);
    background-color: rgba(color(black), 0.25);
    opacity: 1;
  }

  &.is-selected {
    background-color: rgba(color(black), 0.25);
    color: color(white);
    opacity: 1;
    padding: 18px 25px 18px;

    p {
      white-space: normal;
      max-height: 3rem;
    }

    &::before {
      // opacity: 1;
      left: -2px;
    }
  }

  &::before {
    position: absolute;
    top: 0;
    height: 100%;
    width: 10px;
    left: -10px;
    content: '';
    background-color: color(orange);
    // opacity: 0;
    transition: all 0.295s $ease;
  }

  &:first-child {
    border-top-color: rgba(color(white), 0.15);
  }

  &:last-child {
    margin-bottom: 50px;
  }

  h3 {
    margin-top: 0;
    margin-bottom: 0.25rem;
    font-size: 0.85rem;
  }

  p {
    margin: 0;
    color: rgba(color(white), 0.5);
    overflow: hidden;
    font-size: 0.75rem;
    transition: all 0.295s $ease;
    line-height: 1.125rem;
    max-height: 1rem;
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // width: 100%;
  }
}
</style>
